// Radix Select triggers and the shared Combobox both expose role="combobox", so this
// finds the real control ahead of decorations like tooltip icons.
const CONTROL_SELECTOR = 'input:not([type="hidden"]), textarea, select, [role="combobox"]';
const FALLBACK_SELECTOR = 'button, [tabindex]';

/**
 * Scrolls to and focuses the first field with an outstanding error, in visual order.
 * Containers opt in with data-anchor-field="<form field name>" and come back from
 * querySelectorAll in document order, which matches visual order because the form's
 * grids are row-major.
 */
export const anchorFirstInvalidField = (formEl: HTMLElement, errorNames: string[]): void => {
  if (errorNames.length === 0) return;

  const target = Array.from(formEl.querySelectorAll<HTMLElement>('[data-anchor-field]')).find(
    (el) => errorNames.includes(el.dataset.anchorField ?? ''),
  );
  if (!target) return;

  // A container that takes focus itself (tabindex) stands in for controls that can't,
  // such as the time-window picker.
  const focusTarget = target.hasAttribute('tabindex')
    ? target
    : target.querySelector<HTMLElement>(CONTROL_SELECTOR) ??
      target.querySelector<HTMLElement>(FALLBACK_SELECTOR);

  // The hosting DialogContent blurs the focused field on any panel scroll and re-asserts
  // scrollTop after focus, so land the scroll first and focus on the following frame.
  target.scrollIntoView({ block: target.dataset.anchorBlock === 'start' ? 'start' : 'center' });
  requestAnimationFrame(() => focusTarget?.focus({ preventScroll: true }));
};
